export default __webpack_public_path__ + "static/media/CNo.92-1.cd931c82.jpg";